import { Link, useNavigate, useParams } from 'react-router-dom';
import TextInput from '../../components/TextInput';
import React, { useEffect, useRef, useState } from 'react';
import { setBusinessId } from '../../lib/Api';
import { useBusinessInfo, useUserInfoQuery } from '../../lib/Queries';
import useBusinessPostApi from '../../lib/useBusinessPostApi.js';
import * as Toast from '../../lib/Toast.js';
import UsersSettings from '../../components/settings/UsersSettings.jsx';
import useDelete from '../../lib/useDelete.jsx';
import SectionPicker from '../../components/SectionPicker.jsx';
import TextInputWithInlineLabel from '../../components/TextInputWithInlineLabel.jsx';
import SecuritySettings from '../../components/settings/SecuritySettings.jsx';
import BillingSettings from '../../components/settings/BillingSettings.jsx';
import BusinessSettings from '../../components/settings/BusinessSettings.jsx';
import DateTimeSettings from '../../components/settings/DateTimeSettings.jsx';
import ManageFieldSchemas from '../../components/customfields/ManageFieldSchemas.jsx';
import ReferralSettings from '../../components/settings/ReferralSettings.jsx';
import usePermissions from "~/lib/usePermissions";
import PageHeading from "~/components/PageHeading";

const SettingsPage = ({ initalTab }) => {
    const {can} = usePermissions();
    const [section, setSection] = useState(initalTab || 'business');

    useEffect(() => {
        const params = new URL(document.location).searchParams;
        if (params.get('success')) {
            Toast.success('Successfully upgraded account');
        }
    }, []);

    return (
        <div className="pb-20">
            <PageHeading heading="Settings" />

            {can('business') && (
                <SectionPicker
                    className="mb-6"
                    options={[
                        {value: 'business', label: 'Business'},
                        {value: 'datetime', label: 'Date & Time'},
                        {value: 'users', label: 'Users'},
                        {value: 'billing', label: 'Billing'},
                        {value: 'referral', label: 'Referrals'},
                        {value: 'customfields', label: 'Fields'},
                        {value: 'security', label: 'Security'},
                    ].filter(Boolean)}
                    value={section}
                    onChange={setSection}
                    slim={true}
                />
            )}

            {section === 'business' && can('business') && <BusinessSettings />}

            {section === 'datetime' && can('business') && <DateTimeSettings />}

            {section === 'users' && can('users') && <UsersSettings />}

            {(section === 'security' || !can('business')) && <SecuritySettings />}

            {section === 'billing' && can('billing') && <BillingSettings />}

            {section === 'referral' && can('business') && <ReferralSettings />}

            {section === 'customfields' && can('customfields') && <ManageFieldSchemas />}
        </div>
    );
};

export default SettingsPage;
